<template>
  <div class="input-content">
    <input v-model="auxValue" class="fake-input">
    <input
      :id="id"
      v-model="showValue"
      :type="type"
      class="form-input"
      :class="error ? 'input-error' : ''"
      placeholder=" ">
    <label :for="id" class="form-label transition-fast">{{ label }}</label>
    <span v-if="icon" :class="`fa ${icon}`" />
    <span v-else class="prefix">{{ prefix }}</span>
  </div>
</template>
<script>
export default {
  name: 'NumberInput',
  props: {
    id: { type: String, default: '' },
    label: { type: String, default: '' },
    icon: { type: String, default: '' },
    type: { type: String, default: '' },
    prefix: { type: String, default: '' },
    value: { type: Number, default: 0 },
    limit: { type: Number, default: 20 },
    error: { type: Boolean, default: false }
  },
  data() {
    return {
      auxValue: 0,
      showValue: ''
      // crear dos inputs, uno que guarde y envie al padre el valor en numero y el otro solo muestre el formato
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.showValue = this.toNumberFormat(val.toString());
        this.auxValue = val;
      }
    },
    auxValue: {
      immediate: true,
      handler(val) {
        this.$emit('input', val);
      }
    },
    showValue: {
      immediate: true,
      handler(val) {
        return this.responseFormatInput(val);
      }
    }
  },
  methods: {
    onlyNumber(value) {
      return value.replace(/[^0-9,]+/g, '');
    },
    toNumberFormat(value) {
      const numberParts = value.toString().split('.');
      const decimalNumber = numberParts.length > 1 ? `,${numberParts[1]}` : '';
      const newNumber = numberParts[0];
      return newNumber !== '' ? new Intl.NumberFormat('de-DE').format(newNumber) + decimalNumber : '';
    },
    limitControl(value) {
      return value.length > this.limit ? value.substring(0, value.length - 1) : value;
    },
    responseFormatInput(val) {
      const newVal = this.limitControl(
        this.onlyNumber(val).replace(',', '.')
      );
      this.auxValue = Number(newVal);
      this.showValue = this.toNumberFormat(newVal);
    }
  }
};
</script>
<style scoped>
.input-content {
  position: relative;
  margin: auto;
  overflow: hidden;
}
.input-content span.fa, .input-content span.prefix {
  position: absolute;
  bottom: 8px;
  left: 15px;
  margin: auto;
  color: var(--color-moon);
}

.input-content span.prefix {
  color: var(--color-coal);
  font-size: 14px;
  left: 19px;
}
.input-content span.fa {
  bottom: 10px;
}
  .form-label{
    width: 60%;
    font-family: var(--primary-font);
    font-size: 12px;
    margin: 10px auto;
    position: absolute;
    text-align: left;
    left: 0;
    color: var(--primary);
    bottom: 50%;
    padding-left: 14px;
    width: 100%;
  }
  .form-input {
    font: 400 12px var(--primary-font);
    -webkit-appearance: inherit;
    color: var(--color-nickel);
    font-size: 12px;
    margin: auto;
    padding: 10px;
    padding-left: 40px;
    border-radius: 40px;
    background-color:#EFEFEF;
    border: none;
    width: 100%;
    display: block;
    border-bottom: 1px solid transparent;
    transition: all 0.3s;
    margin-top: 30px;
  }
  .fake-input{
    display: none;
  }
  .form-input:placeholder-shown + .form-label{
    color: var(--color-moon);
    bottom: 0%;
    padding-left: 40px;
  }
  .form-input:placeholder-shown {
    margin-top: 0px;
  }
  .form-input:focus{
    outline:0px;
  }
  .form-input.input-error, .form-input:invalid{
    border: 1px solid red;
    box-shadow: inherit;
  }
  /* autofill */
  .form-input:-webkit-autofill::first-line,
  .form-input:-webkit-autofill,
  .form-input:-webkit-autofill:hover,
  .form-input:-webkit-autofill:focus,
  .form-input:-webkit-autofill:active{
    font: 400 12px var(--primary-font);
    font-family: var(--primary-font);
    color: var(--color-nickel) !important;
    transition: all 0.3s;
  }
  .form-input:-webkit-autofill + .form-label {
    width: 60%;
    font-family: var(--primary-font);
    font-size: 12px;
    margin: 10px auto;
    position: absolute;
    text-align: left;
    left: 0;
    color: var(--primary);
    bottom: 50%;
    padding-left: 14px;
    width: 100%;
  }
</style>
